/* esm.sh - applesauce-core@5.2.0/helpers/relay-selection */
export * from "/*applesauce-core@5.2.0/esnext/helpers/relay-selection.mjs";
